import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Compbaser} from "../compbaser";
import {ExperienceLevelType, IFontFormat, ISceneBlock} from "../../interfaces";
import {FontLoaderService, LocalStoreService, StoreSelectorsService} from "../../services";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {fontLibrary, fontLibraryComplete, isHostDevOrLocal, isNullOrUndef, isNullOrUndefOrEmpty, sceneFindKey} from "../../common";
import {ColorPickerService} from "ngx-color-picker";
import {Observable} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {Memoizee} from "../../decorators/memoizee-decorator";
import {FontPreviewComponent, IFontPreview} from "../font-preview/font-preview.component";
import {MatDialog} from "@angular/material/dialog";
import {debounce} from "utils-decorators";
import {Lib} from "../../../libs/Lib";
import * as _ from 'lodash';

@Component({
    selector: 'app-font-selector',
    templateUrl: './font-selector.component.html',
    styleUrls: ['./font-selector.component.scss']
})
export class FontSelectorComponent extends Compbaser implements OnInit {

    // m_styles: string[] = [];
    justificationValue = 'right';
    justificationVerticalValue = 'center';
    selectedFontColor = '#000000';
    m_fonts: Array<string> = [];
    m_contGroup: FormGroup;
    m_colorChangedFunc;
    m_filteredFonts: Observable<string[]>;
    m_currentFontStyles = 'Normal, Normal';
    isFullFeatures: boolean;
    m_hideAlignment = false;
    m_showOnlyVertical = false;
    m_hideVerticalAlignment = false;
    toggle = false;
    old = {};
    isHostDevOrLocal = false;
    theme = 'light';
    fontSizePresets = [6, 8, 10, 12, 14, 16, 18, 21, 24, 28, 32, 36, 42, 48, 56, 64, 72, 80, 96, 104, 120, 144];

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;


    @ViewChild('fontJustification', {static: true}) fontJustification;
    @ViewChild('viewport') viewport: CdkVirtualScrollViewport;

    // tslint:disable-next-line
    @Output() onChange: EventEmitter<IFontFormat> = new EventEmitter<IFontFormat>();

    // In staleMode, ignore all subsequent updates after the first one, used for multi select label
    @Input() staleMode = false;

    @Input()
    set hideAlignment(v) {
        this.m_hideAlignment = true;
    }

    @Input()
    set hideVerticalAlignment(v) {
        this.m_hideVerticalAlignment = true;
    }

    @Input()
    set showOnlyVertical(v) {
        this.m_hideAlignment = true;
        this.m_hideVerticalAlignment = true;
        this.m_showOnlyVertical = true;
    }

    @Input()
    set setConfig(data: { i_config: ISceneBlock, pickArray?: number }) {
        if (!data.i_config) return;
        if (!data.pickArray) data['pickArray'] = 0;

        // In staleMode, ignore all subsequent updates after the first one
        if (this.staleMode && this.old && Object.keys(this.old).length > 0) {
            return;
        }

        let fontData;
        sceneFindKey(data.i_config, 'Font', (values) => {
            fontData = values[data.pickArray];
        });
        this.m_contGroup.controls['fontSize'].setValue(fontData.value["0"].$.fontSize);
        this.m_contGroup.controls['fontFamily'].setValue(fontData.value["0"].$.fontFamily);
        this.m_contGroup.controls['autoScaling'].setValue(fontData.value["0"].$.autoScaling === '1');
        this.m_contGroup.controls['textDecoration'].setValue(fontData.value["0"].$.textDecoration === 'underline');
        this.m_contGroup.controls['wrap'].setValue(fontData.value["0"].$.wrap == '1');
        this.justificationValue = fontData.value["0"].$.textAlign;
        this.justificationVerticalValue = fontData.value["0"].$?.alignSelf;
        if (isNullOrUndef(this.justificationVerticalValue)) this.justificationVerticalValue = 'center';
        this.selectedFontColor = Lib.DecimalToHex(fontData.value["0"].$.fontColor);
        this.m_currentFontStyles = this.getCurrentFontDefault();
        // this.setFontStylesMember();
        // const currentStyle = fontData.value["0"].$.fontWeight + ", " + fontData.value["0"].$.fontStyle;
        // this.setFontStyle(currentStyle);
        this.old = {...this.m_contGroup.value};
    }

    constructor(public el: ElementRef, public fontService: FontLoaderService,
                public fb: FormBuilder,
                public override dialog: MatDialog,
                private storeSelector: StoreSelectorsService,
                private localStoreService: LocalStoreService,
                colorPickerService: ColorPickerService) {
        super();
        this.isHostDevOrLocal = isHostDevOrLocal();
        this.m_colorChangedFunc = _.debounce(() => {
            this.fireChanges('color');
        }, 300);

        this.m_fonts = this.fontService.getFontsScene();
        this.initForm();
    }

    get fontGroup() {
        if (this.m_contGroup) {
            return this.m_contGroup.value;
        } else {
            return {};
        }
    }

    @HostListener("focusout", ["$event.target.value"])
    public fireChanges(e) {
        const key = Object.keys(this.m_contGroup.value).find(k => this.m_contGroup.value[k] != this.old[k]);
        this.old = {...this.m_contGroup.value};
        if (isNullOrUndefOrEmpty(this.m_contGroup.value.fontFamily)) return;
        if (!this.m_fonts.find((f) => f === this.m_contGroup.value.fontFamily)) return;
        // if (key == 'fontFamily') {
        // this.setFontStyle('');
        // this.setFontStylesMember();
        // }
        if (key == 'wrap') {
            this.justificationValue = "left";
            this.justificationVerticalValue = "center";
        }
        if (e != 'color' && e != 'align' && e != 'alignSelf' && key == undefined) return;

        const values: IFontFormat = {
            fontSize: this.m_contGroup.value.fontSize ? this.m_contGroup.value.fontSize : '12',
            fontFamily: this.m_contGroup.value.fontFamily || 'Arial',
            autoScaling: this.m_contGroup.value.autoScaling === true ? '1' : '0',
            fontWeight: 'normal', // this.m_contGroup.value.fontStyle.split(", ")[0],
            textDecoration: 'none', // this.m_contGroup.value.textDecoration === true ? 'underline' : 'none',
            fontStyle: 'normal', // this.cleanNormals(this.m_currentFontStyles),
            // fontStyle: this.isFullFeatures ? this.m_contGroup.value.fontStyle.split(", ")[1] : '',
            wrap: this.m_contGroup.value.wrap === true ? '1' : '0',
            textAlign: this.justificationValue as any,
            alignSelf: this.justificationVerticalValue as any,
            fontColor: String(Lib.HexToDecimal(this.selectedFontColor))
        };

        // if (this.m_contGroup.status !== 'VALID')
        //   return;
        this.onChange.emit(values);
    }

    ngOnInit() {
        // Initialize theme immediately
        this.theme = this.localStoreService.getStorageValConfig('theme') || 'light';
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            })
        );
        this.m_filteredFonts = this.m_contGroup.controls['fontFamily'].valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );

        this.cod(
            this.storeSelector.getLocalStoreUpdates('ILocalStorageConfig').subscribe((e) => {
                this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
                this.theme = this.localStoreService.getStorageValConfig('theme') || 'light'; // Get theme for slider colors
            })
        );
    }

    cleanNormals(i_style): string {
        i_style = i_style.replace(/Normal/gi, '');
        return i_style;
    }

    initForm() {
        this.m_contGroup = this.fb.group({
            fontSize: ['', [Validators.required]],
            // fontFamily: ['', [Validators.required, RequireMatch]],
            fontFamily: ['', [Validators.required]],
            autoScaling: [''],
            textDecoration: [''],
            fontStyle: [{value: '', disabled: false}],
            wrap: ['']
        });
    }

    @debounce(100)
    onChangeDebounced(event) {
        this.fireChanges(event);
    }

    changeCheckbox(event) {
        this.fireChanges(event);
    }

    focusDropdown() {
        if (this.viewport) {
            this.viewport.scrollToIndex(0);
            this.viewport.checkViewportSize();
        }
    }

    checkFontFamily() {
        setTimeout(() => {
            if (this.m_contGroup.value.fontFamily) {
                const v = this.m_contGroup.value.fontFamily.toLowerCase();
                const font = this.m_fonts.find(option => option.toLowerCase() == v);
                if (font) {
                    this.m_contGroup.controls['fontFamily'].setValue(font);
                    this.m_currentFontStyles = this.getCurrentFontDefault();
                    return;
                }
            }
            this.m_contGroup.controls['fontFamily'].setValue('');
            this.m_currentFontStyles = this.getCurrentFontDefault();
        }, 500);
    }

    async eyeDropper() {
        try {
            // @ts-expect-error:
            const eyeDropper = new EyeDropper();
            const selectedColor = await eyeDropper.open();
            if (!selectedColor) return;
            this.selectedFontColor = Lib.EyeDropperConvert(selectedColor.sRGBHex);
            this.selectedFontColor = selectedColor.sRGBHex;
            this.onChangeDebounced('color');
        } catch (err) {
            console.log('color selection cancelled');
        }
    }

    clearFontFamily() {
        this.m_contGroup.controls['fontFamily'].setValue('');
    }

    dialogFontPreview() {
        const dialogRef = this.dialog.open(FontPreviewComponent, {
            height: '800px',
            width: '700px',
            data: {}
        });
        dialogRef.componentInstance.onSelectedFont.subscribe((i_font: IFontPreview) => {
            if (!i_font) return;
            this.m_contGroup.controls['fontFamily'].setValue(i_font.name);
            this.fireChanges(i_font.name);
        });

        // dialogRef.afterClosed().subscribe((i_font: IFontPreview) => {
        //   if (!i_font) return;
        //   this.m_contGroup.controls['fontFamily'].setValue(i_font.name);
        //   this.fireChanges(i_font.name);
        // });
    }

    onVerticalJustificationValueChange(val) {
        this.justificationVerticalValue = val;
        this.fireChanges('alignSelf');
    }

    onJustificationValueChange(val) {
        this.justificationValue = val;
        this.fireChanges('align');
    }

    onColorChanged() {
        this.m_colorChangedFunc();
        // Add extra trigger to ensure color gets applied like font size does
        setTimeout(() => {
            this.fireChanges('color');
        }, 400);
    }

    onFontSizeChange(newSize: number) {
        this.m_contGroup.controls['fontSize'].setValue(newSize);
        this.fireChanges('fontSize');
    }

    /** current we only support one array member as in
     *   "AntoniousOL": [
     *     "Normal,Normal"
     *   ],
     */
    @Memoizee({})
    private getCurrentFontDefault(): string {
        let allFonts;
        if (this.isFullFeatures) {
            allFonts = fontLibraryComplete[this.m_contGroup.value.fontFamily];
        } else {
            allFonts = fontLibrary[this.m_contGroup.value.fontFamily];
        }
        let r = 'Normal, Normal';
        if (!allFonts) {
            return r;
        } else {
            // this.m_styles = allFonts.map((s) => {
            allFonts.map((s) => {
                if (s.split(",").length < 2) {
                    return r;
                } else {
                    r = s.split(",")[0].trim() + ", " + s.split(",")[1].trim();
                }
            });
            return r;
        }
    }


    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.m_fonts.filter(option => option.toLowerCase().includes(filterValue));
    }

    selectedFontFamily(e) {
        this.onChangeDebounced(e);
        // this.setFontStyle('');
        // this.setFontStylesMember();
    }

    setFontStyle(v) {
        this.m_contGroup.controls['fontStyle'].setValue(v);
    }
}


// private setFontStylesMember(): void {
//   let allFonts;
//   if (this.isFullFeatures) {
//     allFonts = fontLibraryComplete[this.m_contGroup.value.fontFamily];
//   } else {
//     allFonts = fontLibrary[this.m_contGroup.value.fontFamily];
//   }
//   if (!allFonts) {
//     this.m_styles = ['Normal', 'Normal'];
//   } else {
//     this.m_styles = allFonts.map((s) => {
//       if (s.split(",").length < 2) {
//         return "Normal, Normal";
//       } else {
//         return s.split(",")[0].trim() + ", " + s.split(",")[1].trim();
//       }
//     });
//   }
// }
// onChangeFontFamily() {
// this.setFontStyle('');
// this.setFontStylesMember();
// }
